module.exports = __webpack_public_path__ + "static/media/14.e95c4b6c.jpg";